import React, { useState } from "react";
import MainButton from "../../../components/shared/button/MainButton";
import styles from "./Calculator.module.scss";
import CalculatorForm from "../../../components/pages/admin-panels/calculator/calculator-form/CalculatorForm";
import GlobalModalComponent from "../../../components/shared/globalModal/GlobalModalComponent";
import i from "../../../assets/images/pages/home/tariff-calculator/i.svg";

export default function Calculator() {
  const [infoModal, setInfoModal] = useState<boolean>(false);

  return (
    <div>
      <div className={styles.calculator_header}>
        <div className={styles.calculator_header_text_container}>
          <p className={styles.calculator_header_title}>Vacib</p>
          <p className={styles.calculator_header_text}>
            Ətir, sprey , tərkibində yanıcı maddə olan mayelər və elektronik
            əşyalar həftədə 1 dəfə xüsusi reyslə göndərilir.
          </p>
        </div>

        <MainButton text="Daha çox" onClick={() => setInfoModal(true)} />
      </div>

      <CalculatorForm />

      {infoModal && (
        <GlobalModalComponent
          isOpen={infoModal}
          onClose={() => setInfoModal(false)}
        >
          <div className={styles.modalContainer}>
            <div className={styles.modal_head}>
              <div className={styles.important}>
                <img src={i} alt="i" />
              </div>
              <h1 className={styles.attention}>Diqqət</h1>
            </div>
            <div className={styles.information_text}>
              <div className={styles.text_wrapper}>
                <h1 className={styles.warning}>
                 Vacib Qeyd: Bağlamanın hər hansı bir tərəfinin (en, uzunluq və ya hündürlük) ölçüsü müəyyən həddi keçərsə, 
                 daşınma haqqı fiziki çəki ilə həcm çəkisi arasında hansı daha böyükdürsə, 
                 onun üzərindən hesablanır.
                 Həcm çəkisinin Beynəlxalq Hava Nəqliyyatı Assosasiyası ( İATA ) qaydalarına uyğun olaraq hesablanma formulu aşağıdakı kimidir :
                </h1>
                <ul className={styles.rules_detail}>
                  <li className={styles.rule_list}>
                   ( En x Uzunluq x Hündürlük) / 8000 = Həcm çəkisi (kq)
                  </li>
                  <li className={styles.rule_list}>
                    Məsələn: 120x20x60/ 6000 = 24 kq
                    24 kq x müvafiq ölkə tarifi = Ümumi daşınma haqqı
                  </li>
                  <li className={styles.rule_list}>
                    Qeyd. Yalnız Çin istiqaməti üzrə: Əgər bağlamanın hər hansı bir tərəfi 60 sm-dən böyükdürsə, həcm çəkisi hesablanır və 8000-ə bölünür.
                  </li>
                  {/* <li className={styles.rule_list}>
                    Digər bütün ölkələr (ABŞ, Türkiyə, Almaniya, İngiltərə, İspaniya):
                    Yalnız bağlamanın hər hansı bir tərəfi 100 sm-dən böyük olduqda həcm çəkisi nəzərə alınır.
                  </li>
                  <li className={styles.rule_list}>
                    Çatdırılma günləri məhsulun Turkiyə anbarına daxil olub və
                    Smart Customsda bəyan edilən gündən sayılır
                  </li> */}
                </ul>
                <div className={styles.additional_info}>
                  Digər bütün ölkələr (ABŞ, Türkiyə, Almaniya, İngiltərə, İspaniya):
                  Yalnız bağlamanın hər hansı bir tərəfi 100 sm-dən böyük olduqda həcm çəkisi nəzərə alınır.
                </div>
              </div>
              <div className={styles.back_button}>
                <MainButton
                  text="Geri dön"
                  onClick={() => setInfoModal(false)}
                />
              </div>
            </div>
          </div>
        </GlobalModalComponent>
      )}
    </div>
  );
}
